/**
 * Created by Rodrigo Quesada on 05/02/17.
 */
import {Injectable} from '@angular/core';
import {Service} from '../../common/service.class';
import {LicensingExamination} from './licensing-examination.model';
import {UserIdentifiedModelListService} from '../../common/user-identified-model-list.service';

@Injectable()
export class LicensingExaminationService extends UserIdentifiedModelListService<LicensingExamination> {

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'licensingExamination', LicensingExamination);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/licenses-certifications/licensingexamination/licensing-examination.service.ts